import { render, staticRenderFns } from "./fixpass.vue?vue&type=template&id=068af67f&"
import script from "./fixpass.vue?vue&type=script&lang=js&"
export * from "./fixpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports